module.exports = __webpack_public_path__ + "img/WHITE_PICTET.d2c9174e.svg";